export const NOTIFICATION_DURATION: number = 2000;

export interface miniCart {
  miniCartTitle: string;
  collapsed: boolean;
}
